export const EmailValue= {
    email: '',
  }